export const EmailValue= {
    email: '',
  }